export default {
      id: "ic_menu_interactive_game-usage",
      viewBox: "0 0 30 21",
      url: "/" + "images/icons.3.109.2.svg#ic_menu_interactive_game-usage",
      toString: function () {
        return this.url;
      }
    }